import { CommonModule } from '@angular/common';
import { CountUpModule } from 'ngx-countup';
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { StatTileComponent } from './stat-tile.component';

@NgModule({
  declarations: [
    StatTileComponent
  ],
  imports: [
    CommonModule,
    CountUpModule,
    NgbTooltipModule,
    RouterModule
  ],
  exports: [
    StatTileComponent
  ]
})

export class StatTileModule { }
